/**
 * Résout le label d'un item (situation ou morning start) selon la langue courante.
 * Fallback : si le label de la langue demandée est null, tente l'autre langue.
 *
 * @param {Object} item   - objet avec les champs {prefix}_fr et {prefix}_en
 * @param {string} prefix - "us_label", "ums_label", "sit_label", "ms_label"
 * @param {string} lang   - "fr" | "en"
 * @returns {string}
 */
export const resolveLabel = (item, prefix, lang) =>
  item[`${prefix}_${lang}`] ||
  item[`${prefix}_fr`] ||
  item[`${prefix}_en`] ||
  "";
